"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _actions = require("./actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reducer = function reducer(state, action) {
  switch (action.type) {
    case _actions.actions.UPSERT:
      {
        state.experimentData[action.name] = action.value; // eslint-disable-line no-param-reassign

        break;
      }

    case _actions.actions.REMOVE:
      {
        delete state.experimentData[action.name]; // eslint-disable-line no-param-reassign

        break;
      }

    case _actions.actions.BULK_UPSERT:
      {
        // eslint-disable-next-line no-param-reassign
        state.experimentData = _objectSpread({}, state.experimentData, {}, action.data);
        break;
      }

    default:
  }
};

var _default = reducer;
exports.default = _default;